import script from "./HomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=1c50e8b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c50e8b1"]])

export default __exports__